import Config from './Config'

// TODO: Define min & max for numbers, allowed values for strings - consolidate with SettingsBox constants
const definedSearchParams = [
  { name: "recentLimit", configProperty: "recentLimit", type: "int" },
  { name: "featureNewImages", configProperty: "featureNewImages", type: "boolean" },
  { name: "refreshMode", configProperty: "refreshMode", type: "string" },
  { name: "transition", configProperty: "transition", type: "string" },
  { name: "autoLayout", configProperty: "autoLayout", type: "boolean" },
  { name: "rows", configProperty: "rows", type: "int" },
  { name: "columns", configProperty: "columns", type: "int" },
  { name: "photoDelay", configProperty: "photoDelay", type: "float" },
  { name: "cycleStartDelay", configProperty: "cycleStartDelay", type: "float" },
  { name: "cycleEndDelay", configProperty: "cycleEndDelay", type: "float" },
  { name: "adDuration", configProperty: "adDuration", type: "float" },
  { name: "cyclesBetweenAds", configProperty: "cyclesBetweenAds", type: "int" },
  { name: "showOneAdPerCycle", configProperty: "showOneAdPerCycle", type: "boolean" },
  { name: "margin", configProperty: "margin", type: "float" },
  { name: "debug", configProperty: "debug", type: "boolean"},
  { name: "backgroundColor", configProperty: "backgroundColor", type: "string" },
  { name: "hideControls", configProperty: "hideControls", type: "boolean" }
]

export function getUrlSearchParams(config: Config, originalConfig: Config): URLSearchParams {
  var params = new URLSearchParams()

  for (let definedParam of definedSearchParams) {
    if ((config as any)[definedParam.configProperty] !== (originalConfig as any)[definedParam.configProperty]) {
      params.set(definedParam.name, (config as any)[definedParam.configProperty].toString())
    }
  }

  if (config.autoLayout) {
    params.delete("rows")
    params.delete("columns")
  }

  return params
}

export function overrideSettingsFromUrl(config: Config): void {
  var params = new URLSearchParams(window.location.search)

  for (let definedParam of definedSearchParams) {
    if (params.has(definedParam.name)) {
      let value: any = params.get(definedParam.name)

      if (value == null) {
        break
      }

      switch (definedParam.type) {
        case "int":
          value = parseInt(value)
          break
        case "float":
          value = parseFloat(value)
          break
        case "boolean":
          value = value === "true"
          break
        default:
          break
      }

      (config as any)[definedParam.configProperty] = value
    }
  }
}